import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { PageType, urlStateToWebUrl } from '@westwing/looks-url-service';
import { useSEOLinks } from '../hooks/useSEOLinks';
import SeoHead from 'Client/components/Generic/SeoHead';
import useConfig from 'Client/hooks/useConfig';
import { SEO_CONSTANTS } from 'Client/components/ListingPage/services/seo/constant';
import StateInterface from 'Client/redux/types';
import { SEODataType } from 'Client/redux/lookDetail/types';
import useRouter from 'Client/hooks/useRouter';
import useBellaTranslator from 'Client/hooks/useTranslator';

export const LDPSeoHead: FC = () => {
    const config = useConfig();
    const { host } = useRouter();
    const t = useBellaTranslator();
    const seoData = useSelector<StateInterface, SEODataType>(state => state.lookDetailPage.look?.seoData);
    const lookName = useSelector<StateInterface, string>(state => state.lookDetailPage.look?.name);
    const lookSlug = useSelector<StateInterface, string>(state => state.lookDetailPage.look?.slug);
    const portraitImage = useSelector<StateInterface, string>(state => state.lookDetailPage.look?.portraitImage);
    const pageDescription = seoData.metaDescription || lookName;
    const robotsIndexAbleContent = seoData.index ? SEO_CONSTANTS.indexable : SEO_CONSTANTS.noIndexable;
    const pageURL = `${host}${urlStateToWebUrl({ pageType: PageType.LDP, look: lookSlug })}`;
    const openGraphImage = portraitImage ? `https:${portraitImage}` : '';
    const pageTitle = `${lookName} | ${t(`So funktioniert unser Look auch bei Ihnen`)}`;

    const links = useSEOLinks(pageURL, seoData.hreflangs);

    return (
        <SeoHead
            config={config}
            pageTitle={pageTitle}
            pageDescription={pageDescription}
            pageUrl={pageURL}
            robotsIndexAbleContent={robotsIndexAbleContent}
            links={links}
            type={SEO_CONSTANTS.ogTypeContentValue}
            openGraphImage={openGraphImage}
        />
    );
};
